export const environment = {
  production: true,

  API_URL: 'https://portal-api-dev.golmn.com/v1/',
  API_TOKEN_URL: 'https://portal-api-dev.golmn.com/token',
  PAYMENTS_FUNCTION_API_URL: 'https://func-lmn-payments-dev.azurewebsites.net/api/',
  GOOGLE_API_KEY: 'AIzaSyAHxIqABLc5b5q_FI4Fpa6ogQZRuRhmpJY',
  AZURE_API_URL: 'https://app-lmn-internal-dev-internal.golmn.com/api/v1',
  CARD_CONNECT_URL: 'https://fts-uat.cardconnect.com/',
  SEJDA_PUBLISHABLE_KEY: 'api_public_fac4b4c1e04a4b7b9c8ff8f1fd8fd77d',
  GA_MEASUREMENT_ID: 'dev',

  PAYRIX_PUBLIC_KEY: '32825e63b3096461dcc1bdaab87637f0',
  PAYRIX_PAYFRAME: 'https://test-api.payrix.com/payFrameScript',
  PAYRIX_PAYFIELDS: 'https://test-api.payrix.com/payFieldsScript',
  PAYRIX_URL: 'https://test-api.payrix.com/',
  LAUNCH_DARKLY_CLIENT_ID: '676195b671eaf00b75c69e88',
  PENDO_KEY: 'b6aced95-30ba-4c88-609f-cdfdb28116a4',

  STRIPE_PUBLISHABLE_KEY_USD: 'pk_test_51RrOy78vYGSHnLrYBX4hIsNRp99tolfcpeYDA4I05F225z7vQOCBS6OJBnsGLpYEpNbrATQfj3QfvELPE97mKhJN00hAF1jQJq',
  STRIPE_PUBLISHABLE_KEY_CAD: 'pk_test_51Rw5LkEsaJRfQRGSg6I9SsHrt8MMVenDwHnRIwXWhrIDAfFsWHQ0ievoiyJA5KGXCBZm1w6e7BJUWV66141sBtwY00OSsbZR73',

  DATA_DOG_ID: '',
  DATA_DOG_ENV: 'dev',
  DATA_DOG_VERSION: '',

  RECAPTCHA_SITE_KEY: '6Ldw3Y4sAAAAAPWOKsVX0gzAUO9oWzGU5tHF5R6h',
};
